import { useSyncExternalStore } from 'react';
import { canInstall, subscribeInstallable } from './installPrompt.js';

/**
 * Whether the browser has handed us an install prompt to show.
 *
 * A subscription rather than a one-off read: the event arrives when the
 * browser decides the site qualifies, which can be seconds after the page is
 * already on screen.
 */
export function useInstallable(): boolean {
  return useSyncExternalStore(subscribeInstallable, canInstall, () => false);
}
